import React from "react";
import { IsEmpty } from "../../../util/commonFunctions";

export const InputElement = props => (
  <React.Fragment>
    <div
      className={
        props.blurred
          ? !props.valid
            ? "invalidIcon " + props.class
            : "validIcon " + props.class
          : props.class
      }
    >
      <input
        id={props.id}
        type={props.type}
        name={props.name}
        value={props.value}
        readOnly={props.readOnly}
        autoComplete="off"
        onBlur={event =>
          props.onBlurHandler(
            event,
            props.formName,
            props.checkButton,
            props.checkForm
          )
        }
        onChange={event =>
          props.onChangeHandler(
            event,
            props.formName,
            props.checkButton,
            props.checkForm
          )
        }
        {...(!IsEmpty(props.placeholder)
          ? { placeholder: props.placeholder }
          : {})}
        {...(!IsEmpty(props.maxLength) ? { maxLength: props.maxLength } : {})}
      />
      {props.noLabel ? "" : <label htmlFor={props.name}>{props.label}</label>}
      {props.name.toLowerCase() == "password" &&
        !IsEmpty(props.belowPlaceholder) && (
          <p className="belowPlaceholder">{props.belowPlaceholder}</p>
        )}
      {!props.valid && <span className="errormsg">{props.errorMsg}</span>}
    </div>
  </React.Fragment>
);

export const Checkbox = props => (
  <React.Fragment>
    <input
      type="checkbox"
      name={props.name}
      defaultChecked={props.checked}
      id={props.id}
      onChange={event =>
        props.onChangeHandler(event, props.formName, props.checkButton)
      }
    />
  </React.Fragment>
);

export const RadioElement = props => (
  <React.Fragment>
    <div className={props.class}>
      <div className="card">
        <div className={props.classWrapper}>
          <input
            type="radio"
            name={props.name}
            checked={props.checked}
            onChange={props.onChangeHandler}
            value={props.value}
          />
          <div className="cell shrink radio-button" />
          <div className="cell auto">{props.label}</div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

export const DropdownListElement = props => (
  <React.Fragment>
    <div className={props.class}>
      <select
        name={props.name}
        value={props.value}
        className={`dropdown ${props.value == "" ? "noValue" : ""}, ${props.selectClass}`}
        onChange={event =>
          props.onChangeHandler(
            event,
            props.formName,
            props.checkButton,
            props.checkForm
          )
        }
        onBlur={event =>
          props.onBlurHandler(
            event,
            props.formName,
            props.checkButton,
            props.checkForm
          )
        }
      >
        <option className="dropdown-option" value="">{props.default || "Please select"}</option>
        {props.options &&
          props.options.map(item => (
            <option className="dropdown-option" value={item.id}>{item.name}</option>
          ))
        }
      </select>
      <label htmlFor={props.name}>{props.label}</label>
      {!props.valid && <span className="errormsg">{props.errorMsg}</span>}
    </div>
  </React.Fragment>
);

export const FileElement = props => (
  <React.Fragment>
    <div className={props.class}>
      <div className="card">
        <div className="secondary text-center">
          <h5>{props.heading}</h5>
          <i className="wue wue-box" aria-hidden="true" />
          <p>{props.description}</p>
        </div>
        <div className="card-section utility text-center">
          <label htmlFor={props.name} className="button expanded">
            {props.label}
            <input
              type="file"
              id={props.name}
              name={props.name}
              className="hide"
              onChange={props.onChangeHandler}
            />
          </label>
          {!props.valid && (
            <span className="input-error-type">{props.errorMsg}</span>
          )}
          <p>{props.typeValid}</p>
        </div>
      </div>
    </div>
  </React.Fragment>
);

export const Submit = props => (
  <React.Fragment>
    <input
      type="submit"
      name="submit"
      value={props.value}
      onClick={props.onChangeHandler}
    />
  </React.Fragment>
);
